import Image from "next/image";
import Link from "next/link";

export const FirstBanner = () => {
  return (
    <Link href="/associacao">
      <div className="relative h-[104vw] max-h-[25.25rem] w-full">
        {/* ===== < lg: empilhado — bloco de texto (cor sólida) em cima + arte embaixo (traços auto-contidos).
            PLACEHOLDER de cor do bloco: #EFF3F4 (borda superior da arte). ===== */}
        <div className="flex h-full w-full flex-col bg-[#EFF3F4] lg:hidden">
          <div className="px-4 pb-2 pt-3 text-center">
            <p className="secondary-font text-[1.25rem] font-extrabold !leading-[1.5rem] text-banner-dark">
              MONTE SEU NEGÓCIO COM A REMIX.
            </p>
            <p className="secondary-font mx-auto mt-1 w-4/5 text-[0.75rem] font-light !leading-[1rem] tracking-wide text-banner-gray">
              Deixe sua criatividade fluir que a gente cuida de tudo.
            </p>
          </div>
          <div
            className="w-full flex-1 bg-center bg-no-repeat"
            style={{
              backgroundImage: "url('/images/home/main_carousel/banner_mobile_loja.png')",
              backgroundSize: "min(80%, 384px) auto",
            }}
          />
        </div>

        {/* ===== ≥ lg: layout panorâmico (arte larga + texto sobreposto à esquerda) ===== */}
        <div className="hidden lg:absolute lg:inset-0 lg:block">
          <div className="absolute left-0 top-0 h-full w-1/2 bg-[#F7F7F7]" />
          <div className="relative z-0 flex h-full w-full flex-col bg-[url('/images/home/main_carousel/banner_desktop_loja.png')] bg-right bg-[length:auto_100%] bg-no-repeat">
            <div className="z-10 ml-12 flex h-full w-2/5 flex-col justify-center gap-4 px-3">
              <div className="text-center">
                <p className="secondary-font w-full text-[2.125rem] font-extrabold !leading-[2.5rem] !tracking-widest text-banner-dark">
                  MONTE SEU NEGÓCIO COM A REMIX.
                </p>
                <p className="secondary-font mb-7 mt-2 w-full text-[1.125rem] font-light !leading-[1.5rem] tracking-wide text-banner-gray">
                  Deixe sua criatividade fluir que a gente cuida de tudo.
                </p>
              </div>
              <div className="w-full font-bold">
                <ul className="flex w-full list-none justify-center pl-0">
                  {["Rentabilidade", "Qualidade", "Facilidade", "Rapidez"].map((word, index) => (
                    <li key={index} className="mr-4 flex flex-row items-center">
                      <Image
                        src="/icons/check.png"
                        alt="Check icon"
                        className="mr-1"
                        width={24}
                        height={24}
                        sizes="24px"
                      />
                      <span className="secondary-font font-bold tracking-wide text-banner-dark">{word}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};
